function roundAffiliateMoney(value) {
  return Math.round(Number(value || 0) * 100) / 100;
}

export function splitAffiliateCommission(totalAmount) {
  const total = roundAffiliateMoney(totalAmount);
  if (!(total > 0)) {
    return { total: 0, byLevel: { 1: 0, 2: 0, 3: 0 } };
  }

  const level1 = roundAffiliateMoney(total * 0.5);
  const level2 = roundAffiliateMoney(total * 0.3);
  const level3 = roundAffiliateMoney(total - level1 - level2);

  return {
    total,
    byLevel: {
      1: level1,
      2: level2,
      3: level3,
    },
  };
}

export function readAffiliateCommissionByLevel(source = {}) {
  const rawByLevel = source?.affiliateCommissionByLevel || {};
  const explicit = {
    1: roundAffiliateMoney(
      rawByLevel?.["1"] ?? rawByLevel?.[1] ?? source?.affiliateLevel1Amount ?? 0,
    ),
    2: roundAffiliateMoney(
      rawByLevel?.["2"] ?? rawByLevel?.[2] ?? source?.affiliateLevel2Amount ?? 0,
    ),
    3: roundAffiliateMoney(
      rawByLevel?.["3"] ?? rawByLevel?.[3] ?? source?.affiliateLevel3Amount ?? 0,
    ),
  };

  if (explicit[1] > 0 || explicit[2] > 0 || explicit[3] > 0) {
    return explicit;
  }

  const total = roundAffiliateMoney(
    source?.affiliateTotalCommissionAmount ??
      source?.affiliateCommissionAmount ??
      source?.commissionAmount ??
      0,
  );

  return splitAffiliateCommission(total).byLevel;
}

export function readAffiliateTotalCommission(source = {}) {
  const byLevel = readAffiliateCommissionByLevel(source);
  return roundAffiliateMoney(byLevel[1] + byLevel[2] + byLevel[3]);
}
